import { FeatureTypes } from "entity-app/constants";
import { sortLinkedItems } from "utils/utils";

export type TSubmittalLinkedBidPackage = {
  id: string;
  number?: string;
  title?: string;
  auto_inc_value?: string | number;
  feature_type_id?: number;
  governing_link?: boolean;
  feature_workflow_instance?: {
    milestone_state?: string;
    risk_level?: string;
    workflow_status?: string;
  };
  workflow_instance_milestones?: Array<{
    sequence_no?: number;
    actual_date?: string | null;
    projected_date?: string | null;
    planned_date?: string | null;
  }>;
  feature_instance_spec_sections?: Array<{
    bid_scope?: boolean;
    spec_section?: {
      section_number?: string;
      section_name?: string;
      title?: string;
    };
  }>;
};

export function getSubmittalLinkedBidPackages(
  featureInstanceData?: {
    links_as_target?: Array<{
      governing_link?: boolean;
      source_feature_instance?: TSubmittalLinkedBidPackage;
    }>;
  } | null
): TSubmittalLinkedBidPackage[] {
  const linksAsTarget = featureInstanceData?.links_as_target;
  if (!linksAsTarget?.length) return [];

  const mapped = linksAsTarget
    .filter(
      (link) =>
        link?.source_feature_instance?.feature_type_id ===
        FeatureTypes.BID_PACKAGE
    )
    .map((link) => ({
      ...link.source_feature_instance,
      governing_link: link.governing_link
    }))
    .filter((instance) => Boolean(instance?.id && instance?.title));

  return sortLinkedItems(
    mapped,
    "auto_inc_value"
  ) as TSubmittalLinkedBidPackage[];
}
